<form [formGroup]="contactForm" class="contact-form">
  @if (submitting) {
    <div class="contact-form-overlay">
      <div class="mp-loader"></div>
    </div>
  }

  <div class="fields">
    <div class="field">
      <label for="field_name" [mpTooltip]="'Pole wymagane'" [mpTooltipPosition]="MpTooltipPosition.Right">Imię <span class="required">*</span></label>
      <input
        id="field_name"
        placeholder="np. Michał"
        autocomplete="given-name"
        required
        [formControlName]="ContactFormControls.Name"
        [class.invalid]="contactForm.get(ContactFormControls.Name).touched && contactForm.get(ContactFormControls.Name).invalid"
        (blur)="validateFormControl(ContactFormControls.Name)"
      />
    </div>
    <div class="field">
      <label for="field_contact" [mpTooltip]="'Pole wymagane'" [mpTooltipPosition]="MpTooltipPosition.Right">Telefon lub e-mail <span class="required">*</span></label>
      <input
        id="field_contact"
        placeholder="+48 123 456 789 / e-mail"
        required
        [formControlName]="ContactFormControls.Contact"
        [class.invalid]="contactForm.get(ContactFormControls.Contact).touched && contactForm.get(ContactFormControls.Contact).invalid"
        (blur)="validateFormControl(ContactFormControls.Contact)"
      />
    </div>
  </div>

  <div class="fields">
    <div class="field">
      <label for="field_type" [mpTooltip]="'Pole wymagane'" [mpTooltipPosition]="MpTooltipPosition.Right">Typ zabudowy <span class="required">*</span></label>
      <div class="select-wrapper">
        <select
          id="field_type"
          required
          [formControlName]="ContactFormControls.FurnitureType"
          [class.invalid]="contactForm.get(ContactFormControls.FurnitureType).touched && contactForm.get(ContactFormControls.FurnitureType).invalid"
          (blur)="validateFormControl(ContactFormControls.FurnitureType)"
        >
          <option [value]="null">Wybierz</option>
          <option [value]="FurnitureType.Kitchen">Kuchnia</option>
          <option [value]="FurnitureType.Wardrobe">Garderoba</option>
          <option [value]="FurnitureType.Closet">Szafa</option>
          <option [value]="FurnitureType.Bathroom">Łazienka</option>
          <option [value]="FurnitureType.Office">Biuro</option>
          <option [value]="FurnitureType.Other">Inna</option>
        </select>
        <i class="fa-sharp fa-regular fa-chevron-down"></i>
      </div>
    </div>
    <div class="field">
      <label for="field_city" [mpTooltip]="'Pole wymagane'" [mpTooltipPosition]="MpTooltipPosition.Right">Miasto / lokalizacja <span class="required">*</span></label>
      <input
        id="field_city"
        required
        [formControlName]="ContactFormControls.Location"
        placeholder="np. Warszawa"
        [class.invalid]="contactForm.get(ContactFormControls.Location).touched && contactForm.get(ContactFormControls.Location).invalid"
        (blur)="validateFormControl(ContactFormControls.Location)"
      />
    </div>
  </div>

  <div class="fields tw-full-width">
    <div class="field">
      <label for="field_description" [mpTooltip]="'Pole wymagane'" [mpTooltipPosition]="MpTooltipPosition.Right">Opis projektu <span class="required">*</span></label>
      <textarea
        id="field_description"
        placeholder="Wymiary, styl, materiały, termin. Możesz wkleić linki do inspiracji."
        required
        [formControlName]="ContactFormControls.Description"
        [class.invalid]="contactForm.get(ContactFormControls.Description).touched && contactForm.get(ContactFormControls.Description).invalid"
        (blur)="validateFormControl(ContactFormControls.Description)"
      ></textarea>
    </div>
  </div>

  <div class="fields tw-full-width">
    <div class="field">
      <label [for]="'field_files'">Inspiracje / rysunki (max 5 plików JPG, PNG lub PDF, każdy max 2MB)</label>
      <app-files-input [inputId]="'field_files'" (filesAdded)="addFiles($event)"></app-files-input>
    </div>
  </div>

  <div class="actions">
    <button class="mp-btn tw-primary tw-small contact-form-submit" type="button" [disabled]="!contactForm.valid || submitting" (click)="submitForm()">Wyślij zapytanie</button>
  </div>
</form>
